import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const TestimonialsSection = () => {
  const { t } = useLanguage();

  const testimonials = [
    {
      quote: t('testimonials.quote1'),
      author: 'Patient Review',
    },
    {
      quote: t('testimonials.quote2'),
      author: 'Patient Review',
    },
    {
      quote: t('testimonials.quote3'),
      author: 'Patient Review',
    },
  ];

  return (
    <section 
      id="testimonials"
      className="section-padding bg-sage relative overflow-hidden"
      aria-labelledby="testimonials-title"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      
      <div className="container-main relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span 
            className="inline-block font-body text-sm uppercase tracking-widest font-semibold text-white/70 mb-4"
            data-testid="testimonials-caption"
          >
            {t('testimonials.caption')}
          </span>
          <h2 
            id="testimonials-title"
            className="font-heading text-4xl md:text-5xl font-semibold text-white tracking-tight mb-6"
            data-testid="testimonials-title"
          >
            {t('testimonials.title')}
          </h2>

          {/* Star Rating Badge */}
          <div 
            className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-6 py-3"
            data-testid="testimonials-rating-badge"
          >
            <div className="flex items-center gap-1" aria-label="5 out of 5 stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 star-icon fill-current" aria-hidden="true" />
              ))}
            </div>
            <span className="font-body font-bold text-white">{t('testimonials.rating')}</span>
            <span className="text-white/70 font-body">({t('testimonials.reviews')})</span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index}
              className="testimonial-card border-white/10 hover:-translate-y-1 transition-transform duration-300"
              data-testid={`testimonial-card-${index}`}
            >
              <CardContent className="p-8">
                {/* Quote Icon */}
                <div className="w-10 h-10 bg-gold/20 rounded-full flex items-center justify-center mb-5">
                  <Quote className="w-5 h-5 text-gold" aria-hidden="true" />
                </div>

                {/* Stars */}
                <div className="flex items-center gap-1 mb-4" aria-label="5 out of 5 stars">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 star-icon fill-current" aria-hidden="true" />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="font-body text-[#1C1C1E] leading-relaxed mb-4">
                  "{testimonial.quote}"
                </blockquote>

                {/* Author */}
                <p className="font-body text-sm text-muted-foreground font-medium">
                  — {testimonial.author}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
